/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Lifetime_LimitsInputs */

const en_pricing_plans_lifetime_limits = /** @type {(inputs: Pricing_Plans_Lifetime_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[]`)
};

const es_pricing_plans_lifetime_limits = /** @type {(inputs: Pricing_Plans_Lifetime_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[]`)
};

/**
* | output |
* | --- |
* | "[]" |
*
* @param {Pricing_Plans_Lifetime_LimitsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_lifetime_limits = /** @type {((inputs?: Pricing_Plans_Lifetime_LimitsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Lifetime_LimitsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_lifetime_limits(inputs)
	return es_pricing_plans_lifetime_limits(inputs)
});